module.exports = __webpack_public_path__ + "static/media/css5.808b8651.png";